<ng-container [ngSwitch]="mode">
  <div
    *ngSwitchCase="'ionic'"
    class="ionic-mode">
    <ion-grid
      class="w-full bg-accent-100 text-center"
      fixed>
      <ng-container *ngFor="let item of data; trackBy: trackByFn">
        <ng-container *ngIf="!item.field.hide">
          <!-- Label -->
          <ng-container *ngTemplateOutlet="label; context: { label: item.name }"></ng-container>

          <ion-row class="ion-align-items-center">
            <ion-col size="8">
              <ion-item
                class="radius-4 body-2"
                [class.item-with-custom-element]="item.field.type === 'custom'"
                [lines]="item.field.type === 'custom' ? 'none' : 'full'">
                <ng-container [ngSwitch]="item.field.type">
                  <!-- type trigger -->
                  <ion-label
                    *ngSwitchCase="'trigger'"
                    class="text-grey-400">
                    {{ item.field.constraint.label }}
                  </ion-label>

                  <!-- type select -->
                  <ion-select
                    *ngSwitchCase="'select'"
                    class="w-full data-type-select"
                    interface="action-sheet"
                    [value]="item.field.value"
                    (ionChange)="tempData[item.key].value = $any($event).detail.value">
                    <ion-select-option
                      *ngFor="let option of item.field.constraint.options; let i = index"
                      [value]="option.value">
                      {{ option.label }}
                    </ion-select-option>
                  </ion-select>

                  <!-- type input -->
                  <ion-input
                    #inputEntry="ngModel"
                    *ngSwitchCase="'input'"
                    appRange
                    ngModel
                    required
                    [placeholder]="item.field.value"
                    [range]="[item.field.constraint.min, item.field.constraint.max]"
                    [type]="item.field.inputType"
                    [value]="item.field.value"
                    (ionChange)="onInputChange(inputEntry.errors, $any($event), item.key)">
                  </ion-input>

                  <!-- type custom -->
                  <ng-container *ngSwitchCase="'custom'">
                    <ng-container
                      *ngTemplateOutlet="item.field.constraint.template;
                        context: { data: item.field.value, changeFn: onChange.bind(this, item) }">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ion-item>
            </ion-col>

            <ion-col size="4">
              <ion-button
                class="radius-4 mt-1"
                color="primary"
                size="small"
                [disabled]="submitDisabled || (item.field.type !== 'trigger' && isSameValue(item.key))"
                (click)="action.emit({ code: item.code, value: tempData[item.key].value, key: item.key })">
                {{ item.field.submit }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ng-container>
      </ng-container>
    </ion-grid>

    <ng-template #label let-label="label">
      <ion-row class="ion-align-items-center">
        <ion-col
          class="text-left pl-3 text-500 text-grey-400"
          size="12">
          <ion-label class="body-2">{{ label }}</ion-label>
        </ion-col>
      </ion-row>
    </ng-template>
  </div>

  <div *ngSwitchCase="'material'">
    <div class="custom-global-browser-setup">
      <ng-container *ngFor="let item of data; trackBy: trackByFn">
        <ng-container *ngIf="!item.field.hide">
          <div
            class="fx-fx-row fx-gap-3 fx-align-start bg-accent-100 radius-4"
            [class.item-with-custom-element]="item.field.type === 'custom'">
            <div class="fx-col p-3 border-1 border-grey-100 radius-4 fx-gap-2 s-full fx-justify-between">
              <!-- Label -->
              <div class="text-normal text-grey-400">
                {{ item.name }}
              </div>
              <div class="fx-row fx-gap-3 fx-center">
                <ng-container [ngSwitch]="item.field.type">
                  <!-- Type trigger -->
                  <div
                    *ngSwitchCase="'trigger'"
                    class="fx-center text-grey-400">
                    {{ item.field.constraint.label }}
                  </div>

                  <!-- Type select -->
                  <mat-form-field
                    *ngSwitchCase="'select'"
                    class="custom-mat-form-field custom-border-bottom">
                    <mat-select
                      [ngModel]="item.field.value"
                      (ngModelChange)="tempData[item.key].value = $event">
                      <mat-option
                        *ngFor="let option of item.field.constraint.options"
                        [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- Type input -->
                  <mat-form-field
                    *ngSwitchCase="'input'"
                    class="custom-mat-form-field custom-border-bottom">
                    <input
                      matInput
                      required
                      [ngModel]="item.field.value"
                      [placeholder]="$any(item.field.value)"
                      [type]="$any(item.field.inputType)"
                      (ngModelChange)="onChange(item, $event)">
                  </mat-form-field>

                  <!-- Type custom -->
                  <div *ngSwitchCase="'custom'">
                    <ng-container *ngTemplateOutlet="item.field.constraint.template;
                      context: { data: item.field.value, changeFn: onChange.bind(this, item) }">
                    </ng-container>
                  </div>
                </ng-container>
                <button
                  class="custom-mat-button-primary"
                  mat-button
                  [disabled]="submitDisabled || (item.field.type !== 'trigger' && isSameValue(item.key))"
                  (click)="action.emit({ code: item.code, value: tempData[item.key].value, key: item.key })">
                  {{ item.field.submit }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
